/**
 * ChatDealSelectedCard — persistent compact confirmation of the deal the user
 * picked from the ChatDealSelectionCard picker. Rendered in ChatPanel from
 * `dealSelectionResolved`, it replaces the picker so the chosen deal remains in
 * the chat instead of the card vanishing on select. The `animate-card-enter`
 * fade+rise gives the picker→confirmation transition a smooth settle.
 *
 * Static by design — to change deals the user just asks again (a fresh
 * request_deal_selection supersedes this confirmation).
 */
import { Check } from 'react-feather';

import { ScoreDisplay } from '../../../components/ui';
import type { SelectableDeal } from '../../../stores/chatStore';

export function ChatDealSelectedCard({ deal }: { deal: SelectableDeal }) {
  return (
    <div className="animate-card-enter mt-2 border border-border bg-surface-card px-3 py-3">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 shrink-0 text-orange">
          <Check size={16} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-body font-semibold text-txt-primary">
            {deal.deal_name || `Deal #${deal.id}`}
          </p>
          {deal.bank_name && (
            <p className="mt-0.5 truncate text-body-sm text-txt-secondary">{deal.bank_name}</p>
          )}
        </div>
        {typeof deal.score === 'number' && (
          <div className="shrink-0">
            <ScoreDisplay score={Math.round(deal.score)} size="sm" showLabel={false} />
          </div>
        )}
      </div>
    </div>
  );
}
